// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-right {\n  position: absolute;\n  top: 40px;\n  right: 0;\n}\n.loader-wrapper {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  width: 100%;\n}\n.loader {\n  left: 50%;\n  max-height: 120px;\n  max-width: 120px;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
